<template>
  <div class="container">
    <div class="nav-tab">
      <div class="top">
        <div class="scrach">
          <input type="text" placeholder="请输入" v-model="searchValue" class="no-outline-input" />
          <div class="button" @click="getlistAll">
            <img src="../../../assets/images/search.png" alt="" />
          </div>
        </div>
      </div>
      <div class="serachItem">
        <div style="display: flex">
          <div style="width: 85px; height: 40px; line-height: 40px">
            结果分类：
          </div>
          <div style="display: flex; flex-flow: wrap">
            <div :class="['items hover-underline', textactive == 99 ? 'textactive' : '']" @click="allList(99)">
              全部(<span :class="total99 > 0 ? 'red' : ''">{{ total99 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 6 ? 'textactive' : '']" @click="allList(6)">
              全国典型案例(<span :class="total6 > 6 ? 'red' : ''">{{ total6 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 7 ? 'textactive' : '']" @click="allList(7)">
              本省典型案例(<span :class="total7 > 0 ? 'red' : ''">{{ total7 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 8 ? 'textactive' : '']" @click="allList(8)">
              市本级典型案例(<span :class="total8 > 0 ? 'red' : ''">{{ total8 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 0 ? 'textactive' : '']" @click="allList(0)">
              贵池(<span :class="total0 > 0 ? 'red' : ''">{{ total0 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 1 ? 'textactive' : '']" @click="allList(1)">
              东至(<span :class="total1 > 0 ? 'red' : ''">{{ total1 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 2 ? 'textactive' : '']" @click="allList(2)">
              石台(<span :class="total2 > 0 ? 'red' : ''">{{ total2 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 3 ? 'textactive' : '']" @click="allList(3)">
              青阳(<span :class="total3 > 0 ? 'red' : ''">{{ total3 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 4 ? 'textactive' : '']" @click="allList(4)">
              九华山(<span :class="total4 > 0 ? 'red' : ''">{{ total4 }}</span>)
            </div>
            <div :class="['items hover-underline', textactive == 5 ? 'textactive' : '']" @click="allList(5)">
              特勤(<span :class="total5 > 0 ? 'red' : ''">{{ total5 }}</span>)
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div style="width: 100px; height: 40px; line-height: 40px">
            时间范围：
          </div>
          <div style="display: flex; flex-flow: row wrap">
            <div style="margin-left: 6px" :class="['items hover-underline', timeactive == 0 ? 'textactive' : '']"
              @click="nonetime">
              时间不限
            </div>
            <div :class="['items hover-underline', timeactive == 1 ? 'textactive' : '']" @click="oneDay">
              一天内
            </div>
            <div :class="['items hover-underline', timeactive == 2 ? 'textactive' : '']" @click="sevenDay">
              一周内
            </div>
            <div :class="['items hover-underline', timeactive == 3 ? 'textactive' : '']" @click="threethDay">
              一个月内
            </div>
            <div :class="['items', timeactive == 4 ? 'textactive' : '']" style="display: flex;">
              <div style="margin-right: 10px;">
                指定时间范围

              </div>
              <div>
                <el-date-picker style="height: 40px;" v-model="value1" type="daterange" value-format="yyyy-MM-dd  "
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>

              </div>
              <div class="hover-underline chax" @click="searchTime">
                搜索
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div>
        搜索<span class="red">{{ searchValue }}</span>，共<span class="red">{{ total }}</span>条结果
      </div>
      <div class="serachItem" v-for="(item, index) in featureList" :key="index">
        <div class="dispFlex">
          <div class="title">
            <div>
              【{{
                infoTypeList.find((items) => items.value == item.messageType)
                  .label
              }}】
            </div>

          </div>
          <div class="contenttitle hover-underline" @click="goInfo(item)">
            {{ item.messageName }}
          </div>
        </div>
        <!-- <div class="content-box">
            <div class="content-box-item" v-html="item.messageContent"></div>
          </div> -->
        <div class="time">发布时间：{{ item.releaseTime }}</div>
      </div>
      <div style="margin-top: 20px">
        <el-pagination @size-change="sizeChange" @current-change="numChange" :page-sizes="[10, 20, 30, 40]"
          :current-page="searchFrom.pageNum" :page-size="searchFrom.pageSize"
          layout="->,total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import { listspecial } from "@/api/index";
import { listReleaseCopy } from "../../../api/index";
export default {
  name: "ImportantNews",
  props: ["searchValues"],
  data() {
    return {
      total: 0,
      featureList: [],
      searchFrom: {
        pageNum: 1,
        pageSize: 10,
        status: 4,
      },
      infoTypeList: [
        { label: "贵池", value: 0 },
        { label: "东至", value: 1 },
        { label: "石台", value: 2 },
        { label: "青阳", value: 3 },
        { label: "九华山", value: 4 },
        { label: "特勤", value: 5 },
        { label: "全国典型案例", value: 6 },
        { label: "本省典型案例", value: 7 },
        { label: "市本级典型案例", value: 8 },
      ],
      startDate: "",
      endDate: "",
      textactive: 99,
      timeactive: 0,
      total0: 0,
      total1: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      total5: 0,
      total6: 0,
      total7: 0,
      total8: 0,
      total99: 0,
      messageType: "",
      value1: [],
      searchValue: '',
    };
  },
  mounted() {
    this.searchValue = this.searchValues;
    this.getlistAll();
  },
  methods: {
    searchTime() {
      console.log(this.value1);
      this.searchFrom.startDate = this.value1[0]
      this.searchFrom.endDate = this.value1[1]
      this.getlistAll()
    },
    goInfo(item) {
      // 使用window.open方法在新窗口或选项卡中打开链接
      let url = '';
      if (item.fileUrl) {
        url = item.fileUrl;
        window.open(url, "_blank");
      }
    },
    formatDate(date) {
      return date.toISOString().split("T")[0].trim(); // 格式化为 YYYY-MM-DD
    },
    getlistAll() {
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: this.messageType,
      }).then((res) => {
        this.featureList = res.data.data.list;
        this.total = res.data.data.total;
      });
      this.getlistAlltotal();
    },

    nonetime() {
      this.searchFrom.startDate = "";
      this.searchFrom.endDate = "";
      this.timeactive = 0;
      this.getlistAll();
      this.value1 = []
    },
    oneDay() {
      this.timeactive = 1;
      this.getCurrentDate();
      this.getPreviousDay();
    },
    sevenDay() {
      this.timeactive = 2;
      this.getCurrentDate();
      this.getLastWeek();
    },
    threethDay() {
      this.timeactive = 3;
      this.getCurrentDate();
      this.getLastMonth();
    },
    formatDate(date) {
      return date.toISOString().split("T")[0]; // 格式化为 YYYY-MM-DD
    },
    getCurrentDate() {
      const currentDate = new Date();
      this.searchFrom.endDate = this.formatDate(currentDate);
    },
    getPreviousDay() {
      const previousDay = new Date();
      previousDay.setDate(previousDay.getDate() - 1);
      this.searchFrom.startDate = this.formatDate(previousDay);
      this.value1 = []
      this.getlistAll();
    },
    getLastWeek() {
      const lastWeek = new Date();
      lastWeek.setDate(lastWeek.getDate() - 7);
      this.searchFrom.startDate = this.formatDate(lastWeek);
      console.log(this.searchFrom.endDate);
      this.value1 = []
      this.getlistAll();
    },
    // 月份
    getLastMonth() {
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      this.searchFrom.startDate = this.formatDate(lastMonth);
      console.log(this.searchFrom.endDate);
      this.value1 = []
      this.getlistAll();
    },
    allList(active) {
      this.textactive = active;
      this.messageType = active;
      if (this.messageType == 99) {
        this.messageType = "";
      }
      this.value1 = []
      this.getlistAll();
    },
    // 分页器
    numChange(page) {
      this.searchFrom.pageNum = page;
      this.value1 = []
      this.getlistAll();
    },
    sizeChange(val) {
      this.searchFrom.pageSize = val;
      this.value1 = []
      this.getlistAll();
    },

    getlistAlltotal() {
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
      }).then((res) => {
        this.total99 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 0,
      }).then((res) => {
        this.total0 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 1,
      }).then((res) => {
        this.total1 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 2,
      }).then((res) => {
        this.total2 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 3,
      }).then((res) => {
        this.total3 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 4,
      }).then((res) => {
        this.total4 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 5,
      }).then((res) => {
        this.total5 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 6,
      }).then((res) => {
        this.total6 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 7,
      }).then((res) => {
        this.total7 = res.data.data.total;
      });
      listReleaseCopy({
        ...this.searchFrom,
        searchValue: this.searchValue,
        messageType: 8,
      }).then((res) => {
        this.total8 = res.data.data.total;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  background: #f0f5ff;
}

.chax {
  margin-left: 8px;
  text-align: center;
  line-height: 26px;
  margin-top: 7px;
  color: #fff;
  width: 48px;
  height: 28px;
  background: #2B56AC;
  border-radius: 0px 0px 0px 0px;
}

.dispFlex {
  width: 1080px;
  flex: 1;
  /* 使子项平分可用空间 */
  min-width: 0;
  /* 允许子项缩小到 0 */
  display: flex;
  flex-flow: row nowrap;
}

.textactive {
  font-weight: bold;
  color: #2b56ac;
}

.nav-tab {
  width: 1080px;
  background: #f5f5f5;

  margin: 0 auto;
  padding: 40px 20px 20px 20px;

  .serachItem {
    .items {
      margin-left: 22px;
      height: 40px;
      line-height: 40px;
    }
  }

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }

  .scrach {
    width: 100%;
    display: flex;
    justify-content: center;

    .no-outline-input {
      width: 560px;
      height: 40px;
    }

    .button {
      width: 40px;
      height: 44px;
      background: #2b56ac;
      border-radius: 0 4px 4px 0;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 18px;
        height: 20px;
      }
    }
  }
}

.content {
  width: 1080px;
  background-color: #fff;
  margin: 0 auto;
  padding: 20px;

  .serachItem {
    margin: 20px 0;

    .content-box {
      margin: 16px 0;
    }

    .content-box-item {
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .title {
      text-align: center;
      height: 30px;
      line-height: 30px;
      width: 120px;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      background-color: #355dac;
    }

    .contenttitle {
      overflow: hidden;
      /* 隐藏溢出的内容 */
      white-space: nowrap;
      /* 不换行 */
      text-overflow: ellipsis;
      /* 溢出时使用省略号 */
      padding: 6px;
      font-weight: 600;
      font-size: 14px;
      color: #333333;
    }

    .time {
      font-weight: 400;
      font-size: 14px;
      color: #c1c5cd;
    }
  }
}

.hover-underline {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline;
  /* 悬停时添加下划线 */
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}

.hover-underline {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline;
  /* 悬停时添加下划线 */
}

.red {
  color: #e71111;
}
</style>